import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import InternalTvContentBlockData from 'app/Models/Content/InternalTvContentBlockData';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import {getImageProps} from 'app/utilities/ImageProps';

const InternalTvContentBlock = ({data, context}: ComponentProps<InternalTvContentBlockData>) => {
  return (
    <div>
      <Image {...getImageProps(data.image, context)} />
      <span>{data.title.value}</span>
    </div>
  );
};

export default InternalTvContentBlock;
